import { FiCheck } from "react-icons/fi";
import { toast } from "react-toastify";
import SystemMessage from "~/components/themed/SystemMessage";
import useUserPemissions from "~/hooks/useUserPermissions";
import { EventBySlugOutput } from "~/types/EventTypesInferred";
import { api } from "~/utils/api";
import { isValidVenue } from "~/utils/event";
import { Button } from "./Button";

const ValidVenueAlert = ({ event }: { event: EventBySlugOutput }) => {
    const apiCtx = api.useUtils();

    const { isManager, isAdmin, isHost } = useUserPemissions({
        event: event || null,
    });

    const confirmVenue = api.event.hostValidVenueConfirmation.useMutation();

    const handleConfirmVenue = async () => {
        toast.loading("Confirming venue...", {
            toastId: "confirm-venue",
        });

        await confirmVenue.mutateAsync(
            {
                eventId: event.id,
                slug: event.slug,
            },

            {
                onSuccess: () => {
                    toast.success("Venue confirmed!", {
                        autoClose: 1000,
                    });
                },
                onError: () => {
                    toast.error("Something went wrong!", {
                        autoClose: 1000,
                    });
                },
                onSettled: () => {
                    toast.dismiss("confirm-venue");
                    apiCtx.event.getBySlug.refetch();
                },
            },
        );
    };

    if (event.hostHasConfirmedIsValidLocation || event.isVirtual) return null;

    if ((isManager || isAdmin || isHost) && !isValidVenue(event)) {
        return (
            <>
                <SystemMessage
                    title="Invalid venue"
                    message={`
                    The specified address does not seem to point to a venue. Press the button below to confirm that ${
                        !!event.location ? event.location : "this"
                    } is the correct location.
                    `}
                    footer={
                        <Button
                            variant="secondary"
                            className="h-[30px] py-1"
                            onClick={handleConfirmVenue}
                        >
                            <FiCheck className="h-4 w-4" />
                            Confirm event venue location
                        </Button>
                    }
                />
            </>
        );
    }

    return null;
};

export default ValidVenueAlert;
